

import React, {Component} from 'react';
import { Redirect  } from "react-router-dom";


class HotelItem extends Component {

    state = {
        redirect : null
    }


    DisplayForHotelDetails = (hotelId) => {        

        console.log('DisplayForDetails hotelId', hotelId);
        this.props.DisplayForHotelDetails(hotelId);

        //this.setState({ redirect: "/hotelDetails" }); 
        //this.setState({ redirect: "/hotelDetails/" + hotelId}); 
    }


    
  render() { 

    
    if (this.state.redirect) {        
        return <Redirect to={this.state.redirect} />
    }           
    return (     

        <div className="inner_col_hotel">

            <div className="inner_col_hotel_upper_part">
                <div className="inner_col_htl_main_title">{this.props.hotel.HotelName}</div>
                <div className="inner_col_htl_sec_title_container">
                    <span className="inner_col_htl_sec_title">{this.props.hotel.HotelArea}</span>
                </div>
            </div>
            <div className="inner_col_hotel_img">
                <img src={this.props.hotel.HotelPic1}  alt=""/>
            </div>


            <div className="inner_col_hotel_bottom_part">
                <div className="inner_col_htl_details_font paddingTop5">
                    <span className="marginRight15 inner_col_htl_details_2">
                        <span className="marginRight5">
                            {this.props.hotel.CosherType}
                        </span>
                    </span>
                   
                </div>

                <div className="orderButton" onClick={ () => 
                    this.DisplayForHotelDetails(this.props.hotel.Id)}>
                    <div className="orderArrow">
                        <img src={"/images/site/arrow-next.png"} alt=""/>                
                    </div>
                    <div className="hotelDetailsText">פרטי מלון</div>
                </div>

            </div>
        </div>
    )
  }
}

export default HotelItem;
